import React, { FC } from "react";
import { LuCheck } from "react-icons/lu";

import { KindIcon, Sentence, UnreadDot } from "./NotificationParts";
import { NotificationItem } from "./notifications.types";
import {
  notificationFullTime,
  notificationText,
  notificationTimeLabel,
} from "./notifications.utils";

type Props = {
  items: NotificationItem[];
  onOpen: (item: NotificationItem) => void;
  /** Undefined = no Done button (database update pending). */
  onDone?: (item: NotificationItem) => void;
};

/** Compact notification rows for the bell drop-down and the Home card. */
export const NotificationMiniList: FC<Props> = ({ items, onOpen, onDone }) => (
  <>
    {items.map((item) => (
      <div
        key={item.id}
        role={"button"}
        tabIndex={0}
        aria-label={notificationText(item)}
        onClick={() => onOpen(item)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && e.target === e.currentTarget) onOpen(item);
        }}
        className={
          "group flex w-full cursor-pointer items-start gap-3 border-b border-[#F0F1F4] py-3 text-left last:border-b-0 hover:bg-[#F9F9FB] focus-visible:bg-[#F9F9FB] focus-visible:outline-none"
        }>
        <KindIcon category={item.category} size={"sm"} />
        <span className={"min-w-0 flex-1"}>
          <Sentence
            item={item}
            className={"line-clamp-2 block text-[13px] leading-[1.45]"}
          />
          <span
            className={
              "mt-1 flex items-center gap-2 text-[11.5px] text-[#8A90A2]"
            }>
            {item.clientName && (
              <span className={"truncate"}>{item.clientName}</span>
            )}
            {item.clientName && <span aria-hidden={"true"}>·</span>}
            <span
              title={notificationFullTime(item.date)}
              className={"whitespace-nowrap"}>
              {notificationTimeLabel(item.date)}
            </span>
          </span>
        </span>
        <span className={"flex flex-none items-center gap-1 pt-1"}>
          {onDone && (
            <button
              type={"button"}
              title={"Done"}
              aria-label={"Done"}
              onClick={(e) => {
                e.stopPropagation();
                onDone(item);
              }}
              className={
                "flex h-7 w-7 items-center justify-center rounded-[7px] text-[14px] text-[#6B7185] opacity-0 hover:bg-[#F0EDFF] hover:text-[#6B4EFF] focus-visible:opacity-100 group-hover:opacity-100"
              }>
              <LuCheck />
            </button>
          )}
          <UnreadDot show={!item.isRead} />
        </span>
      </div>
    ))}
  </>
);
